import { Swiper, Autoplay, Pagination } from 'swiper';

export default function setupSlider(className, players = null) {
  // eslint-disable-next-line no-new
  const slider = new Swiper(className, {
    modules: [Autoplay, Pagination],
    slidesPerView: 1,
    spaceBetween: 15,
    autoplay: {
      delay: 5000
    },
    pagination: {
      el: `${className}-pagination`,
      clickable: true
    }
  });

  if (players && players.length) {
    slider.on('slideChange', () => {
      players.forEach((player) => player.stop());
    });
  }
}
